module.exports = "dw-input-group .ant-input input {\n  color: rgba(0, 0, 0, 0.65);\n}\n"